import React from 'react';
import PropTypes from 'prop-types';

import FormElement from './form-element';
import Icon from '../icon/icon';

import './select.scss';
import './form-element.scss';

const Select = ({ id, inline, inputRef, name, options, ...props }) => {
    if (!name) {
        name = id;
    }

    // Convert array of strings to value and label options objects
    if (typeof options[0] === 'string') {
        options = options.map(option => ({ label: option, value: option }));
    }

    return (
        <FormElement type="select" inline={inline}>
            <select
                {...props}
                className="select"
                id={id}
                name={name}
                ref={inputRef}
            >
                {options && options.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                ))}
            </select>
            <Icon type="spinner" size="small" />
        </FormElement>
    );
};

Select.propTypes = {
    defaultValue: PropTypes.string,
    id: PropTypes.string.isRequired,
    inline: PropTypes.bool,
    inputRef: PropTypes.func,
    name: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.string
        })
    ]))
};

Select.defaultProps = {
    defaultValue: undefined,
    inline: false,
    inputRef: () => {},
    name: null,
    options: []
};

export default Select;
